import { isAfter, sub } from "date-fns";

export function isCurrentTimeWithin24HoursOf(date: Date) {
  const now = new Date();
  const twentyFourHoursBefore = sub(date, { hours: 24 });

  return isAfter(now, twentyFourHoursBefore);
}
